/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  resetPassword(id, credentials) {
    return axios.patch(`${this.url}/${id}/password`, { agent: credentials });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  updateAccess(id, disabled) {
    return axios.patch(`${this.url}/${id}/access`, { agent: { disabled } });
  }

  getOffboarding(id) {
    return axios.get(`${this.url}/${id}/offboarding`);
  }

  transferAndRemove(id, replacementAgentId) {
    return axios.delete(`${this.url}/${id}`, {
      data: { replacement_agent_id: replacementAgentId },
    });
  }

  updateMasterRole(id, data) {
    return axios.patch(`${this.url}/${id}/master_role`, { agent: data });
  }
}

export default new Agents();
